function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import cx from "clsx";
import { styled, useThemeProps } from "@mui/material/styles";
import { infoClasses } from "./infoClasses";
import { InfoTitle } from "./InfoTitle";
import { InfoSubtitle } from "./InfoSubtitle";
import { InfoEyebrow } from "./InfoEyebrow";
import { InfoCaption } from "./InfoCaption";

var defaultUseStyles = () => ({});

var StylesContext = /*#__PURE__*/React.createContext(undefined);
export var useStylesCtx = () => {
  var value = React.useContext(StylesContext);

  if (!value) {
    throw new Error("`useStylesCtx` must be called under <Info>");
  }

  return value;
};
var InfoRoot = styled("div", {
  name: "JunInfo",
  slot: "Root",
  overridesResolver: (props, styles) => {
    var {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant]];
  }
})((_ref) => {
  var {
    theme,
    ownerState
  } = _ref;
  return _extends({
    display: "block"
  }, ownerState.useStyles && ownerState.useStyles(theme).root);
});
export var Info = /*#__PURE__*/React.forwardRef(function Info(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: "JunInfo"
  });

  var {
    children,
    component,
    variant,
    useStyles
  } = props,
      other = _objectWithoutPropertiesLoose(props, ["children", "component", "variant", "useStyles"]);

  var ownerState = _extends({}, props, {
    variant,
    useStyles
  });

  return /*#__PURE__*/React.createElement(InfoRoot, _extends({
    ref: ref
  }, other, {
    as: component,
    className: cx(infoClasses.root, props.className),
    ownerState: ownerState
  }), /*#__PURE__*/React.createElement(StylesContext.Provider, {
    value: useStyles || defaultUseStyles
  }, children));
});
Info.Title = InfoTitle;
Info.Subtitle = InfoSubtitle;
Info.Eyebrow = InfoEyebrow;
Info.Caption = InfoCaption;